<template>
    <!-- Progress Bar -->
    <div class="flex">
        <h2 class="font-bold leading-tight">{{ title }}</h2>
        <span class="text-sm ml-3 leading-tight">{{ progress.completed_steps }} of {{ progress.total_steps }} steps completed</span>
    </div>
    <div class="w-full bg-gray-200 rounded-full h-2">
      <div class="bg-blue-600 h-2 rounded-full" :style="`width: ${progress.completion_percentage}%`"></div>
    </div>

    <div :hidden="1==1">
        <!-- Step List with Icons -->
        <div v-for="(step, stepName) in stepStatus" :key="stepName" class="flex items-center p-4">
            <!-- Completion Icon -->
            <div class="mr-4">
                <fa-icon v-if="step.is_completed"
                        :icon="'check-circle'"
                        class="text-green-500 text-xl" />
                <fa-icon v-else-if="step.is_current"
                        :icon="'circle-dot'"
                        class="text-blue-500 text-xl" />
                <fa-icon v-else
                        :icon="'circle'"
                        :class="step.is_locked ? 'text-gray-300' : 'text-gray-500'"
                        class="text-xl" />
            </div>

            <!-- Step Info -->
            <div :class="step.is_locked ? 'opacity-50' : ''">
                <h3>Step {{ step.step_number }}: {{ getStepDisplayName(stepName) }}</h3>
            </div>
        </div>
    </div>
  </template>

  <script>
  export default {
    props: {
      title: String,
      application: Object,
      stepCompletionStatus: Object,
      stepProgressData: Object,
      completedStepsMap: Object
    },
    computed: {
      stepStatus() {
        return this.stepCompletionStatus || {};
      },
      progress() {
        return this.stepProgressData || {};
      }
    },
    methods: {
      getStepDisplayName(stepName) {
        const names = {
          'terms_and_conditions': 'Terms and Conditions',
          'payment': 'Payment',
          'personal_information': 'Personal Information',
          'credit_background_report': 'Credit & Background Report',
          'financial_documents': 'Financial Documents',
          'identity_verification': 'Identity Verification',
          'income_verification': 'Income Verification',
          'assets_verification': 'Assets Verification',
          'share_report': 'Share Report'
        };
        return names[stepName] || stepName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
      }
    }
  }
  </script>